<template>
  <div v-if="getLabelforBrand() && brandUrl[getLabelforBrand()]">
    <router-link :to="localizedRoute('/' + brandUrl[getLabelforBrand()])" class="no-underline">
      <img :src="'/assets/logo/' + getLabelforBrand() + '.png'" alt="brand logo" width="100px" height="auto">
    </router-link>
  </div>
</template>

<script>
export default {
  data () {
    return {
      brandUrl: {
        'adidas Originals': 'adidas',
        'ASICS Tiger': 'asics-tiger',
        'Carhartt WIP': 'carhartt-wip',
        'Champion': 'champion',
        'Crep Protect': 'crep-protect',
        'EASTPAK': 'eastpak',
        'FILA': 'fila',
        'Happy Socks': 'happy-socks',
        'Hermetic Square': 'hermetic-square',
        'HUF': 'huf',
        'KAPPA': 'kappa',
        'Komono': 'komono',
        'Le Coq Sportif': 'le-coq-sportif',
        "Levi's": 'levi-s',
        'New Balance': 'new-blalnce',
        'Nike': 'nike',
        'Produkt własny': 'produkt-wlasny',
        'PUMA': 'puma',
        'Saucony': 'saucony',
        'Secrid': 'secrid',
        'The North Face': 'the-north-face',
        'Vans': 'bans',
        'Wood Wood': 'wood-wood',
        'Street Supply': 'street-supply',
        'Sneaker Freaker': 'sneaker-freaker',
        'Reebok': 'reebok',
        'Hypebeast': 'hypebeast',
        'Fjällräven': 'fjallraven',
        'Columbia': 'columbia'
      }
    }
  },
  props: {
    brand: {
      type: [String, Number],
      required: true
    }
  },
  methods: {
    getLabelforBrand () {
      if (this.listByCode && this.listByCode['brand']) {
        let label = this.listByCode['brand'].options.filter((option) => { return option.value === String(this.brand) })
        if (label && label.length) {
          return label[0].label
        } else {
          return false
        }
      }
    }
  },
  computed: {
    listByCode () {
      return this.$store.state.attribute.list_by_code
    }
  }
}
</script>
